import { useViewjobProctorAllocation } from "../../proctor/__generated__/ViewjobProctorContext";
import { MobVjMatchOverviewResumeGateTst } from "../../proctor/__generated__/ViewjobProctorSpecifications";
import { useViewjobOneGraphModel } from "../context/ViewJobDataContext";

/**
 * Returns whether the Match Overview should be gated behind adding a resume
 * (MJP-880). True only when the seeker has no resume on file AND is in the
 * experiment's test bucket.
 */
export function useMatchOverviewResumeGate(): boolean {
  const hasResume = useViewjobOneGraphModel()?.jobSeeker.profile.hasResume ?? false;
  const isProctorActive = useViewjobProctorAllocation(MobVjMatchOverviewResumeGateTst).isTest;

  return !hasResume && isProctorActive;
}
